/**
 * Parses an HTTP `Retry-After` header value into a delay in seconds.
 * Supports delay-seconds and HTTP-date forms; returns `undefined` when absent or invalid.
 */
export function parseRetryAfterSeconds(
  header: string | null | undefined,
  now = Date.now(),
): number | undefined {
  if (!header) {
    return undefined;
  }

  const seconds = Number(header);
  if (!Number.isNaN(seconds) && seconds >= 0) {
    return seconds;
  }

  const dateMs = Date.parse(header);
  if (!Number.isNaN(dateMs)) {
    return Math.max(0, Math.ceil((dateMs - now) / 1000));
  }

  return undefined;
}
